import {
  SET_BUSINESS_DAY_SETTINGS_DATA_LOADING,
  SET_BUSINESS_DAY_SETTINGS_DATA,
  CLEAR_BUSINESS_DAY_SETTINGS_DATA,
} from '../actions/types';

const initialState = {
  isLoading: false,
  businessDaySettingsData: [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_BUSINESS_DAY_SETTINGS_DATA_LOADING:
      return {
        ...state,
        isLoading: payload,
      };
    case SET_BUSINESS_DAY_SETTINGS_DATA:
      return {
        ...state,
        businessDaySettingsData: Array.isArray(payload) ? [...payload] : [],
        isLoading: false,
      };
    case CLEAR_BUSINESS_DAY_SETTINGS_DATA:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
